import React from 'react';
import { Input, Label, LabelContents, LabelText, InputWrapper, Description } from './view';

interface Props {
    label: string;
    className?: string;
    description?: string;
    checked?: boolean;
    disabled?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    name: string;
    value: any;
    id: string;
    oneRow?: boolean;
    isDangerSelection?: boolean;
    cy?: string;
}

const RadioButton: React.FC<Props> = ({ label, name, id, oneRow, disabled, className, description, cy, ...props }) => (
    <InputWrapper className={className}>
        <Input
            id={id}
            type="radio"
            name={name}
            disabled={disabled}
            data-cy={cy}
            {...props}
        />
        <Label
            disabled={disabled}
            htmlFor={id}
        >
            <LabelContents oneRow={oneRow}>
                <LabelText
                    color="inherit"
                    variant="body1R"
                >
                    {label}
                </LabelText>
                <Description
                    colorVariant="second"
                    variant="body3"
                >
                    {description}
                </Description>
            </LabelContents>
        </Label>
    </InputWrapper>
);

export default RadioButton;
